import { render, staticRenderFns } from "./OpsCollectionsCreate.vue?vue&type=template&id=d20d00e0&"
import script from "./OpsCollectionsCreate.vue?vue&type=script&lang=js&"
export * from "./OpsCollectionsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports